/* global G */
import { curry, getKey, isArr } from 'lib/util'
import asObject from 'lib/sequence/component/children/asObject'
import { resolve } from 'lib/manager/acl/helper'

/**
 * model attribute acl getter
 *
 * This getter compares the ACLs of the provided `attribute` sub-model
 * with the ACLs defined in the module config.
 *
 * @example config
 * { ..., options: { ..., events: { ..., acl: 'modelOrganisation', ... }}}
 * @example module/[name]/events.js
 * import acl from 'app/_shared/acl/model'
 * export default { ..., acl: { modelOrganisation: modelAttribute('organisation') }, ...}
 *
 * @param {string} attribute              sub-model to use
 * @param {Gaia.AppModule.Spec} module    the current module composition object
 * @param {Gaia.Component.Spec} component the current action's main component
 * @param {String} key                    the component's `key`
 * @returns {boolean|*}
 */
const acl = (attribute, module, component, { key }) => {
  const model = module[G.MODEL][G.CHILDREN][attribute]
  const documentAcl = model[G.CACHE].acl
  const item = getKey(key, asObject(component[G.CHILDREN]))
  const componentAcl = !item[G.ACL] ? null : resolve(item)

  if (!isArr(componentAcl?.[G.ACL])) return true

  try {
    return module[G.ADAPTER][G.ACL].model(componentAcl[G.ACL], documentAcl)
  } catch (e) {
    return componentAcl[G.PROPS]
  }
}

export default curry(acl)
